module.exports = __webpack_public_path__ + "static/media/beep.5a020f67.wav";